import React from "react";

import {
  Checkbox,
  FormControlLabel,
  Grid
} from "@material-ui/core";

function CustomSingleCheckbox(props) {
  const { label, index, name, value, isDynamicField, onChange, type } = props.componentObject;

  return (
    <Grid container>
      <Grid item xs={12} md={4}>
      </Grid>
      <Grid item container xs={12} md={7}>
        <Grid item xs={6} style={{ marginBottom: 20 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(value)}
                color="primary"
                onChange={(e) => onChange(e.target.checked, index, type, isDynamicField)}
                name={name}
              />
            }
            label={label}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CustomSingleCheckbox;

